import React, { useState, useRef, useContext } from 'react'
import { ButtonHeading, ConsigneeDetailsTab } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import LoadingBar from 'react-top-loading-bar';
import { useLocation, useNavigate } from 'react-router-dom';
import SupplierSettingsTab from 'components/MastersDetailsTabs/SupplierSettingsTab/SupplierSettingsTab';
import { UserContext } from 'context';

const ConsigneeDetails = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const consigneeName = queryParams.get('name') || '';
    const loadingBarRef = useRef(null);
    const { masterData, setMasterDetailsList } = useContext(UserContext);
    const [activeTab, setActiveTab] = useState(1);
    const [singleConsignee, setSingleConsignee] = useState(null)

    const tabProps = {
        tabList: constant.consigneeDetailsTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab
    }

    const handleConsigneeData = (data) => {
        setSingleConsignee(data)
    }

    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <ButtonHeading
                title={consigneeName ? consigneeName : singleConsignee?.name}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/consignee'); setMasterDetailsList({}) }} // navigate(-1)
            />

            <div className='addPr_flBx'>
                <Tab {...tabProps} />
                {activeTab === 1 && (
                    <ConsigneeDetailsTab
                        onDataFetch={handleConsigneeData}
                        loadingBarRef={loadingBarRef}
                        isConsigneeTaxInfo={true}
                    />
                )}
                {activeTab === 2 && <SupplierSettingsTab name='addressBook' />}
            </div>
        </div>
    )
}

export default ConsigneeDetails;